import { gql } from "@apollo/client";
import { Box, Stack } from "@chakra-ui/react";
import { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";

import { NominalCodeForm } from "../../../components/NominalCodeForm";
import { PageTitle } from "../../../components/Page";
import { Panel } from "../../../components/Panel";
import { buildAdminNominalCodeListPath } from "../../../config/routes";
import { useNominalCodeCreationPageCreateNominalCodeMutation } from "../../../generated/graphql";

export const Nominal_CODE_CREATION_PAGE_CREATE_Nominal_CODE = gql`
  mutation NominalCodeCreationPageCreateNominalCode($input: CreateNominalCodeInput!) {
    createNominalCode(input: $input) {
      id
    }
  }
`;

export const NominalCodeCreationPage = () => {
  const navigate = useNavigate();

  const [createNominalCode] = useNominalCodeCreationPageCreateNominalCodeMutation({
    refetchQueries: ["GetNominalCodes"],
  });

  return (
    <Fragment>
      <Helmet>
        <title>WMS | New Nominal Code</title>
      </Helmet>

      <Stack spacing={6} px={8} py={5}>
        <Stack width="100%" isInline justifyContent="space-between">
          <PageTitle>New Nominal Code</PageTitle>
        </Stack>

        <Panel maxWidth="900px">
          <Box px={8} py={5}>
            <NominalCodeForm
              onSubmit={async (values) => {
                await createNominalCode({
                  variables: {
                    input: values,
                  },
                });

                navigate(buildAdminNominalCodeListPath());
              }}
            />
          </Box>
        </Panel>
      </Stack>
    </Fragment>
  );
};
